//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TextLink from 'components/blocks/TextLink.vue';


export default {
  name: "expandable",
  block: ['expandable'],
  props: ['data','active','index','icon','rotate45','iconLeft','height'],
  data() {
    return {
      defaultHeight: 90,
      contentHeight: 90
    }
  },
  computed: {
    expandedHeight(){
      return (!this.$el)? 0 : this.$el.querySelectorAll('.expandable-content')[0].clientHeight;
    }
  },
  components: {
    TextLink
  },
  methods: {
    changeExpandable(index) {
      index = (index == this.active) ? null : index;
      this.$emit('activeExpandableChanged', index);
    },
    setExpandableBlockHeight() {
      if(this.active == this.index) {
        this.contentHeight = this.expandedHeight + this.defaultHeight;
      } else {
        this.contentHeight = this.defaultHeight;
      }
    },
    getBlockModifiers() {
      let bms = this.block;
      if (this.data.blockModifiers) {
        this.data.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }

      return bms;
    },
  },
  watch: {
    active() {
      this.setExpandableBlockHeight();
    },
  },
  mounted() {
    if (this.height != null) {
      this.defaultHeight = this.height;
      this.contentHeight = this.height;
    }
      
    let heightHandler = setInterval(()=>{
      // Configure content height when component is created
      if (this.$el != null && this.expandedHeight != 0) {
        this.setExpandableBlockHeight();
        clearTimeout(heightHandler);
      }
    },50);
  }
}



// WEBPACK FOOTER //
// ./components/blocks/Expandable.vue